import { Box, Button, TextField } from "@mui/material";
import { DemoItem } from "@mui/x-date-pickers/internals/demo";
import React, { useEffect, useRef, useState } from "react";
import DateRangePicker from "rsuite/DateRangePicker";
import "rsuite/DateRangePicker/styles/index.css";
import Dropdown from "rsuite/Dropdown";
import "rsuite/Dropdown/styles/index.css";
import { isTemperatureDevice, notShowSavingReportByHouseName, reportPosition, reportType } from "./data";
import "./Report.css";
import { useSelector } from "react-redux";
import { messages } from "../../../common/notification";
import {
  calculateUnitReport,
  loadLogsReport,
  savingReport,
  temperatureReport,
  hourlyUnitsDataReport,
  doorAnalyzeReport,
  systemOnTimeReport,
  dgMixerRatioReport,
  doorAnalyzeCompleteReport,
  plantEnergyReport,
  kwhUnitLogsReport,
  deviceWiseDailyReport,
  deviceWiseDailyKvahReport,
  averageHourlyTemperatureReport,
  areaWiseTemperatureReport,
} from "./function";
import { Spinner, Table } from "react-bootstrap";
import moment from "moment";
import { CSVLink } from "react-csv";
import Select, { components } from "react-select";
import CreatableSelect from "react-select/creatable";
import { fetchAllHouses, fetchHouseDetails } from "../../../redux/action/house";
import store from "../../../redux";
import { pages } from "../../../../ApiRoute";
import { reportTypes } from "../../../redux/actionTypes";

// Dropdown option rendered with a checkbox; "Select All" is checked when every option is selected
const CheckboxOption = (props) => {
  const { data, isSelected, options, selectProps } = props;
  // No checkbox for single-select dropdowns or the creatable "Add device ID" option
  if (!selectProps.isMulti || data.__isNew__) return <components.Option {...props} />;
  const selectedValues = (selectProps.value || []).map((v) => v.value);
  const realOptions = options.filter((o) => o.value !== "select_all" && !o.__isNew__);
  const checked =
    data.value === "select_all"
      ? realOptions.length > 0 && realOptions.every((o) => selectedValues.includes(o.value))
      : isSelected;
  return (
    <components.Option {...props}>
      <input
        type="checkbox"
        checked={checked}
        readOnly
        style={{ marginRight: "8px", cursor: "pointer" }}
      />
      {data.label}
    </components.Option>
  );
};

// Chrome ignores autoComplete="off" (react-select's default) and autofills the
// search box with a previously typed value; an unrecognised token disables it.
const NoAutofillInput = (props) => <components.Input {...props} autoComplete="new-password" />;

function Report() {
  const { afterToday } = DateRangePicker;
  const unitReport = useSelector((state) => state.unitReport);
  // const houseData = useSelector(state => state.houseData);

  const housesList = useSelector((state) => state.housesList);
  const mutipleHouse = useSelector((state) => state.mutipleHouse);
  const [energiSync, setEnergiSync] = useState([]);
  const [doorSensor, setDoorSensor] = useState([])
  const [selectedDoorSensor, setSelectedDoorSensor] = useState("")
  const [temperatureThreshold, setTemperatureThreshold] = useState("2")
  const [dateRange, setDateRange] = useState({
    startDate: null,
    endDate: null,
  });
  const [selectedReportType, setSelectedReportType] = useState({
    value: "Select",
    name: "Select",
  });
  const [selectedDevices, setSelectedDevices] = useState([]);
  const [selectedHouse, setSelectedHouse] = useState([]);
  const [houseData, setHouseData] = useState({});
  const [housesLoading, setHousesLoading] = useState(false);
  const [houseSearch, setHouseSearch] = useState("");

  // Keep the typed search text after selecting a property, so the filtered
  // list stays in place; clear it only when the menu closes or input blurs.
  const handleHouseInputChange = (inputValue, { action }) => {
    if (action === "input-change") setHouseSearch(inputValue);
    if (action === "menu-close" || action === "input-blur") setHouseSearch("");
  };
  const [equipmentSearch, setEquipmentSearch] = useState("");
  const handleEquipmentInputChange = (inputValue, { action }) => {
    if (action === "input-change") setEquipmentSearch(inputValue);
    if (action === "menu-close" || action === "input-blur") setEquipmentSearch("");
  };

  // Fetch the latest property list every time the Property dropdown is opened
  const handleHouseMenuOpen = async () => {
    const mobile = store.getState().login?.profile?.mobile;
    if (!mobile) return;
    setHousesLoading(true);
    await fetchAllHouses(mobile.slice(3));
    setHousesLoading(false);
  };

  const handleDateChange = (range) => {
    if (range) {
      const [startDate, endDate] = range;
      setDateRange({ startDate: startDate, endDate: endDate });
    }
  };

  useEffect(() => {
    let totalEnergy = [];
    let totalDoorSensor = [];
    if (Object.keys(mutipleHouse).length > 0 && selectedHouse.length > 0) {
      for (let house of selectedHouse) {
        if (mutipleHouse[house.value] === undefined) continue
        let houseData = mutipleHouse[house.value]
        if (houseData.rooms.length > 0) {
          for (let room of houseData.rooms) {
            if (room.doorSensors.length > 0) {
              for (let device of room.doorSensors) {
                totalDoorSensor.push({ roomName: room.roomName, ...device, houseName: houseData.houseName, houseId: houseData._id });
              }
            }
            if (room.energiSync.length > 0) {
              for (let device of room.energiSync) {
                totalEnergy.push({ roomName: room.roomName, ...device, houseName: houseData.houseName, houseId: houseData._id });
              }
            }
          }
        }
      }

    }

    setEnergiSync(totalEnergy);
    setDoorSensor(totalDoorSensor)
  }, [mutipleHouse, selectedHouse]);
  // Handler to toggle select all
  const handleChange = (selected) => {
    let options = housesList.map((e) => {
      return {
        value: e.houseAccessCode,
        label: e.houseName,
      };
    })
    // Check if "Select All" option was clicked
    if (selected && selected.some((option) => option.value === "select_all")) {
      // Select All functionality
      setSelectedHouse(
        selected.length === options.length + 1 ? [] : [...options]
      );
    } else {
      setSelectedHouse(selected);
    }
  };
  // Temperature reports only list temperature devices
  const isTemperatureReport = [
    reportType[reportPosition.avgHourlyTemperature].name,
    reportType[reportPosition.areaWiseTemperature].name,
  ].includes(selectedReportType.name);
  const equipmentDevices =
    isTemperatureReport
      ? energiSync.filter((e) => isTemperatureDevice(e.deviceId))
      : energiSync;
  const handleChangeEnergyDevice = (selected) => {
    let options = equipmentDevices.map((e) => {
      return {
        ...e,
        value: e.deviceId,
        label: `${e.name !== undefined && e.name !== ""
          ? `${e.name}-${e.deviceId}`
          : e.deviceId
          }`,
      };
    })
    // Check if "Select All" option was clicked
    if (selected && Array.isArray(selected) && selected.some((option) => option.value === "select_all")) {
      // Select All functionality
      setSelectedDevices(
        selected.length === options.length + 1 ? [] : [...options]
      );
    } else {
      setSelectedDevices(selected);
    }
  };
  // Lets a device id be typed in directly, for reports that can pull data for
  // a device even when it is not part of the currently selected property.
  const handleCreateDevice = (inputValue) => {
    const deviceId = inputValue.trim();
    if (!deviceId) return;
    const device = { value: deviceId, label: deviceId, deviceId };
    // System OnTime is single-select, so the typed device replaces the selection
    if (selectedReportType.name === reportType[reportPosition.systemOnTime].name) {
      setSelectedDevices(device);
    } else {
      setSelectedDevices((prev) => [...(Array.isArray(prev) ? prev : []), device]);
    }
    setEquipmentSearch("");
  };
  const handleChangeDoorSensor = (selected) => {
    setSelectedDoorSensor(selected);
  };
  // Fetch details only for newly selected properties; ones already fetched on
  // this page are kept in redux (mutipleHouse) and don't need a refetch.
  const fetchedHouseIds = useRef(new Set());
  useEffect(() => {
    const loginDetails = store.getState().login;

    const mobileWithoutCountryCode =
      loginDetails?.profile?.mobile.slice(3);
    for (let i of selectedHouse) {
      if (fetchedHouseIds.current.has(i.value)) continue;
      fetchedHouseIds.current.add(i.value);
      fetchHouseDetails(
        i.value,
        mobileWithoutCountryCode,
        pages.reportPage
      );
    }
  }, [selectedHouse])
  return (
    <Box>
      <Box className="d-flex text-start align-items-end gap-5">
        <Box sx={{ minWidth: '200px' }}>
          <DemoItem className="text-start">Property</DemoItem>
          <Select
            className="react-select-container-house-report"
            classNamePrefix="react-select-house-report"
            style={{ width: "100% !important" }}
            options={[{ value: "select_all", label: "Select All" }, ...housesList.map((e) => {
              return {
                value: e.houseAccessCode,
                label: e.houseName,
              };
            })]}
            closeMenuOnSelect={false}
            hideSelectedOptions={false}
            inputValue={houseSearch}
            onInputChange={handleHouseInputChange}
            components={{ Option: CheckboxOption, Input: NoAutofillInput }}
            isMulti
            isLoading={housesLoading}
            onMenuOpen={handleHouseMenuOpen}
            value={selectedHouse}
            onChange={(data) => {


              handleChange(data)
            }}
          />
        </Box>
        <Box sx={{ minWidth: "150px" }}>
          <DemoItem className="text-start">Report Type</DemoItem>
          <Dropdown
            title={selectedReportType.name}
            style={{ minWidth: "150px" }}
          >
            {reportType
              .filter((rep) => {
                if (
                  notShowSavingReportByHouseName.includes(houseData.houseName)
                ) {
                  if (rep.name !== reportType[4].name) {
                    return rep;
                  }
                } else {
                  return rep;
                }
              })
              .map((r) => {
                return (
                  <Dropdown.Item onClick={() => { setSelectedReportType(r); setSelectedDevices([]); setSelectedDoorSensor([]) }}>
                    {r.name}
                  </Dropdown.Item>
                );
              })}
          </Dropdown>
        </Box>
        {
          selectedReportType.name !== 'Select' && (
            <Box>
              <DemoItem className="text-start">Select Date</DemoItem>
              <DateRangePicker
                shouldDisableDate={afterToday()} // Disable future dates
                onChange={handleDateChange}
                placeholder="Select Date Range"
                value={Object.values(dateRange)}
                {...(selectedReportType.name === reportType[8].name
                  ? { oneTap: true, showOneCalendar: true }
                  : {})}
                ranges={[]}
              />
            </Box>
          )
        }



        {[reportType[7].name, reportType[reportPosition.doorAnalyzeComplete].name].includes(selectedReportType.name) && (
          <Box>
            <DemoItem className="text-start">Select Door Sensor</DemoItem>
            <Select
              className="d-flex react-select-container-house-report"
              closeMenuOnSelect={false}
              isMulti={false}
              classNamePrefix="react-select-house-report"
              options={[{ value: "", label: "Select" }, ...doorSensor.map((e) => {
                return {
                  ...e,
                  value: e.deviceId,
                  label: `${e.name !== undefined && e.name !== ""
                    ? `${e.name}-${e.deviceId}`
                    : e.deviceId
                    }`,
                };
              })]}
              value={selectedDoorSensor}
              onChange={(data) => {
                handleChangeDoorSensor(data)
              }}
            />
          </Box>
        )}
        {[
          reportType[reportPosition.logs].name,
          reportType[reportPosition.kvah].name,
          reportType[reportPosition.hourlyUnits].name,
          reportType[reportPosition.systemOnTime].name,
          reportType[reportPosition.kwhUnitLogs].name,
          reportType[reportPosition.deviceWiseDaily].name,
          reportType[reportPosition.deviceWiseDailyKavh].name,
          reportType[reportPosition.avgHourlyTemperature].name,
          reportType[reportPosition.areaWiseTemperature].name,
        ].includes(selectedReportType.name) && (
          <Box>
            <DemoItem className="text-start">Select Equipment</DemoItem>
            <CreatableSelect
              className="d-flex react-select-container-house-report"
              closeMenuOnSelect={false}
              isMulti={selectedReportType.name !== reportType[8].name}
              hideSelectedOptions={false}
              components={{ Option: CheckboxOption, Input: NoAutofillInput }}
              inputValue={equipmentSearch}
              onInputChange={handleEquipmentInputChange}
              classNamePrefix="react-select-house-report"
              options={[{ value: "select_all", label: "Select All" }, ...equipmentDevices.map((e) => {
                return {
                  ...e,
                  value: e.deviceId,
                  label: `${e.name !== undefined && e.name !== ""
                    ? `${e.name}-${e.deviceId}`
                    : e.deviceId
                    }`,
                };
              })]}
              value={selectedDevices}
              onChange={(data) => {
                handleChangeEnergyDevice(data)
              }}
              onCreateOption={handleCreateDevice}
              isValidNewOption={(inputValue) => {
                const deviceId = inputValue.trim();
                if (!deviceId) return false;
                // Temperature reports only accept temperature device ids
                if (isTemperatureReport) {
                  return isTemperatureDevice(deviceId);
                }
                return [
                  reportType[reportPosition.logs].name,
                  reportType[reportPosition.hourlyUnits].name,
                  reportType[reportPosition.systemOnTime].name,
                  reportType[reportPosition.kwhUnitLogs].name,
                  reportType[reportPosition.deviceWiseDaily].name,
                  reportType[reportPosition.deviceWiseDailyKavh].name,
                ].includes(selectedReportType.name);
              }}
              formatCreateLabel={(inputValue) => `Add device ID "${inputValue}" (not in this property)`}
            />
          </Box>
        )}
        {
          selectedReportType.name === reportType[reportPosition.doorAnalyzeComplete].name && (
            <Box>
              <DemoItem className="text-start">Temperature Threshold</DemoItem>
              <TextField
                type="number"
                variant="outlined"
                size="small"
                sx={{ backgroundColor: "#fff" }}
                value={temperatureThreshold}
                onChange={(e) => {
                  setTemperatureThreshold(e.target.value);
                }}
              />
            </Box>
          )

        }
        <Box>
          <Button
            variant="contained"
            onClick={() => {
              if (
                selectedReportType.value === "Select" ||
                dateRange.startDate === null ||
                dateRange.endDate === null
              ) {
                messages.error("Select All Values");
                return;
              }
              if (energiSync.length === 0) {
                messages.error("There is no devices in selected house");
                return;
              }
              if (selectedReportType.value === reportType[0].value) {
                calculateUnitReport(dateRange, energiSync, selectedReportType, selectedHouse);
              }
              if (selectedReportType.value === reportType[13].value) {
                if (selectedDevices.length === 0) {
                  messages.error("Equipment not selected");
                  return;
                }
                deviceWiseDailyReport(dateRange, selectedDevices, selectedReportType, selectedHouse);
              }
              if (selectedReportType.value === reportType[reportPosition.deviceWiseDailyKavh].value) {
                if (selectedDevices.length === 0) {
                  messages.error("Equipment not selected");
                  return;
                }
                deviceWiseDailyKvahReport(dateRange, selectedDevices, selectedReportType, selectedHouse);
              }
              if (selectedReportType.value === reportType[5].value) {
                // calculateUnitKvaHReport(dateRange, energiSync, selectedReportType,selectedHouse)
                setDateRange({ startDate: new Date("2024-11-01"), endDate: new Date("2024-12-31") })
                const link = document.createElement("a");
                link.href = `https://s3.ap-south-1.amazonaws.com/alistetechnologies.com/01-11-2024-30-11-2024_Property_Meter_Reading.csv`;
                link.download = "01-11-2024 - 31-12-2024_Property Meter Reading.csv";
                link.click();
              }
              if (selectedReportType.value === reportType[2].value) {
                temperatureReport(dateRange, energiSync, selectedHouse);
              }
              if (selectedReportType.value === reportType[reportPosition.logs].value) {
                if (selectedDevices.length === 0) {
                  messages.error("Equipment not selected");
                  return;
                }
                loadLogsReport(dateRange, selectedDevices, selectedHouse);
              }
              if (selectedReportType.value === reportType[4].value) {
                savingReport(dateRange, energiSync, selectedHouse);
              }
              if (selectedReportType.value === reportType[6].value) {
                if (selectedDevices.length === 0) {
                  messages.error("Equipment not selected");
                  return;
                }
                hourlyUnitsDataReport(dateRange, selectedDevices, selectedHouse);
              }
              if (selectedReportType.value === reportType[7].value) {
                if (Object.keys(selectedDoorSensor).length === 0) {
                  messages.error("Door Sensor not selected");
                  return;
                }
                doorAnalyzeReport(dateRange, selectedDoorSensor, selectedHouse);
              }
              if (selectedReportType.value === reportType[8].value) {
                if (!selectedDevices) {
                  messages.error("Equipment not selected");
                  return;
                }
                systemOnTimeReport(dateRange, selectedDevices, selectedHouse);
              }
              if (selectedReportType.value === reportType[9].value) {
                if (Object.keys(dateRange).length === 0) {
                  messages.error("Date Range not selected");
                  return;
                }
                dgMixerRatioReport(dateRange, energiSync, selectedHouse);
              }
              if (selectedReportType.value === reportType[reportPosition.doorAnalyzeComplete].value) {
                if (Object.keys(dateRange).length === 0) {
                  messages.error("Date Range not selected");
                  return;
                }
                doorAnalyzeCompleteReport(dateRange, selectedDoorSensor, energiSync, temperatureThreshold);
              }
              if (selectedReportType.value === reportType[reportPosition.plantEnergy].value) {
                if (Object.keys(dateRange).length === 0) {
                  messages.error("Date Range not selected");
                  return;

                }
                plantEnergyReport(dateRange, energiSync, selectedHouse);
              }
              if (selectedReportType.value === reportType[reportPosition.kwhUnitLogs].value) {
                if (selectedDevices.length === 0) {
                  messages.error("Equipment not selected");
                  return;
                }
                kwhUnitLogsReport(dateRange, selectedDevices, selectedHouse);
              }
              if (selectedReportType.value === reportType[reportPosition.avgHourlyTemperature].value) {
                if (selectedDevices.length === 0) {
                  messages.error("Equipment not selected");
                  return;
                }
                averageHourlyTemperatureReport(dateRange, selectedDevices);
              }
              if (selectedReportType.value === reportType[reportPosition.areaWiseTemperature].value) {
                if (selectedDevices.length === 0) {
                  messages.error("Equipment not selected");
                  return;
                }
                areaWiseTemperatureReport(dateRange, selectedDevices);
              }
            }}
          >
            Get Report
          </Button>
        </Box>
      </Box>

      <Table striped bordered hover className="mt-3">
        <thead>
          <tr>
            <th>#</th>
            <th>Date Range</th>
            <th>Type</th>
            <th>Percentage</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {Object.keys(unitReport.reports).map((id, index) => {
            let date = unitReport.reports[id].date;
            return (
              <tr key={id}>
                <td>{index + 1}</td>
                <td>{`${moment(date.startDate).format("DD-MM-YYYY")} - ${moment(
                  date.endDate
                ).format("DD-MM-YYYY")}`}</td>
                <td>{unitReport.reports[id].type}</td>
                <td>{
                  ((unitReport.reports[id]?.currentCall / unitReport.reports[id]?.totalCalls) * 100).toFixed(0)
                }%</td>
                <td>
                  {unitReport.reports[id].data.length > 0 &&
                    unitReport.reports[id].success === true ? (
                    <button className="btn btn-primary">
                      <CSVLink
                        data={unitReport.reports[id].data}
                        filename={`${moment(date.startDate).format(
                          "DD-MM-YYYY"
                        )} - ${moment(date.endDate).format("DD-MM-YYYY")}_${unitReport.reports[id].type
                          }.csv`}
                        style={{ textDecoration: "none", color: "white" }}
                      >
                        {" "}
                        Download
                      </CSVLink>
                    </button>
                  ) : unitReport.reports[id].data.length === 0 &&
                    unitReport.reports[id].success === true ? (
                    <button className="btn btn-primary" disabled>
                      Data Not Available
                    </button>
                  ) : unitReport.reports[id].data.length === 0 &&
                    unitReport.reports[id].success === false ? (
                    <button className="btn btn-danger">Failed</button>
                  ) : (
                    <button className="btn btn-primary" disabled>
                      <Spinner
                        as="span"
                        animation="grow"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                      />
                      Loading...
                    </button>
                  )}
                </td>
              </tr>
            );
          })}
        </tbody>
      </Table>
      <Box className="mt-5" style={{ height: "20px" }}></Box>
    </Box>
  );
}

export default Report;
